const navBarInlineReducer = (state = true, action) => {
  switch (action.type) {
    case 'CHANGE_NAVBAR_INLINE_STATUS': {
      return action.payload
    }
    default:
      return state
  }
}
export default navBarInlineReducer